import { regionDisplayName } from '../utils/formatRegion';
import RegionDetailsForm from '../RegionDetailsForm';
import styles from '../blocks.module.css';

function blockHelp({ blockName, caseScoped }) {
    if (blockName) {
        return caseScoped
            ? `Applies to every slide that uses block ${blockName} on this case. Other blocks or cases can differ.`
            : `Applies to every slide that uses block ${blockName}. Other blocks can differ.`;
    }
    return caseScoped
        ? 'Applies to every slide that uses this block on this case. Other blocks or cases can differ.'
        : 'Applies to every slide that uses this block. Other blocks can differ.';
}

function slideHelp(blockName) {
    if (blockName) {
        return `Applies to this slide only. To update every slide from block ${blockName}, change the region on that block.`;
    }
    return 'Applies to this slide only. Shared changes belong on the block.';
}

/**
 * In-sheet region details (no modal overlay).
 * scope: 'block' (shared across slides from this block) | 'slide' (this slide only)
 *
 * When hideFooter is true (default for sheet parents), Cancel/Save live in the sheet
 * sticky footer; pass actionsRef + onDirtyChange from the parent.
 */
export default function RegionDetailsSubview({
    region,
    blockName,
    scope = 'block',
    caseScoped = false,
    onBack,
    onSave,
    readOnly = false,
    backLabel,
    hideFooter = true,
    onDirtyChange = null,
    actionsRef = null,
}) {
    const isSlide = scope === 'slide';
    const label = regionDisplayName(region) || 'Region';
    const title = isSlide
        ? (blockName ? `${label} on ${blockName}` : label)
        : (blockName
            ? `${label} on block ${blockName}${caseScoped ? ' (this case)' : ''}`
            : label);
    const help = isSlide ? slideHelp(blockName) : blockHelp({ blockName, caseScoped });
    const resolvedBack = backLabel || (isSlide ? '← Back' : '← Back to regions');
    const saveLabel = isSlide ? 'Save changes' : 'Save region details';

    return (
        <div className={styles.subview}>
            <div className={styles.subviewNav}>
                <button type="button" className={styles.linkButton} onClick={onBack}>
                    {resolvedBack}
                </button>
            </div>
            <h4 className={styles.subviewTitle}>{title}</h4>
            <p className={styles.jobText}>{help}</p>
            <RegionDetailsForm
                region={region}
                open
                layout="embedded"
                hideChrome
                hideFooter={hideFooter}
                saveLabel={saveLabel}
                onSave={onSave}
                onCancel={onBack}
                readOnly={readOnly}
                definitionContext={!isSlide}
                onDirtyChange={onDirtyChange}
                actionsRef={actionsRef}
            />
        </div>
    );
}
